/**
 * @flow
 * @relayHash 478ef4ab2476f571a97041085d397af3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LogUserDataConsentInput = {
  userId: string,
  consentString: string,
  isGlobalConsent: boolean,
  clientMutationId?: ?string,
};
export type LogUserDataConsentMutationVariables = {|
  input: LogUserDataConsentInput
|};
export type LogUserDataConsentMutationResponse = {|
  +logUserDataConsent: ?{|
    +success: boolean
  |}
|};
export type LogUserDataConsentMutation = {|
  variables: LogUserDataConsentMutationVariables,
  response: LogUserDataConsentMutationResponse,
|};
*/


/*
mutation LogUserDataConsentMutation(
  $input: LogUserDataConsentInput!
) {
  logUserDataConsent(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "LogUserDataConsentInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "logUserDataConsent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "LogUserDataConsentInput!"
      }
    ],
    "concreteType": "LogUserDataConsentPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "success",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "LogUserDataConsentMutation",
  "id": null,
  "text": "mutation LogUserDataConsentMutation(\n  $input: LogUserDataConsentInput!\n) {\n  logUserDataConsent(input: $input) {\n    success\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "LogUserDataConsentMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "LogUserDataConsentMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c2bf60f75d4c0a834c5677312a6bc346';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/LogUserDataConsentMutation.graphql.js